<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称">
					<el-select v-model="filters.mn" filterable  multiple collapse-tags  style="width:300px" >
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker
                        v-model="filters.time" type="date"  value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow ResetButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<!-- 天数据展示 -->
		<el-table :data="dataDayList" border highlight-current-row v-loading="listLoading" style="width: 100%;" :max-height="formHeight" 
		@selection-change="selsChangeDay"    size="small" >
			<el-table-column type="selection"> </el-table-column>
			<el-table-column type="index" label="序号"  fixed></el-table-column>
            <el-table-column prop="projectName" label="项目名称"  sortable  ></el-table-column>
			<el-table-column prop="siteName" label="点位名称"  sortable  ></el-table-column>
            <!-- <el-table-column prop="manufacturerName" label="设备厂商"  sortable  ></el-table-column> -->
            <el-table-column prop="time" label="时间"  sortable  ></el-table-column>
			<el-table-column prop="ld" label="Ld(dB)"  sortable  ></el-table-column>
			<el-table-column prop="ln" label="Ln(dB)"  sortable  ></el-table-column>
			<el-table-column prop="ldn" label="Ldn(dB)"  sortable  ></el-table-column>
           	<el-table-column v-for="item in reviewWays"
				:prop="item.keyword" :label="item.name" :key="item.keyword" >
				<template slot-scope="scope">
					<span v-if="item.keyword=='preReview'">
						<span v-if="scope.row[item.keyword+'Status']==0">
							<el-button  type="info"  size="small" disabled>未标记</el-button>
						</span>
						<span v-else-if="scope.row[item.keyword+'Status']==1"  @click="showStatus(scope.$index, scope.row,item.keyword,'通过','标记')" >
							<el-button  type="success" size="small">通过</el-button>
						</span>
						<span v-else   @click="showStatus(scope.$index, scope.row,item.keyword,'异常','标记')" >
							<el-button  type="danger"  size="small" >异常</el-button>
						</span>
					</span>
					<span v-else>
						<span v-if="scope.row[item.keyword+'Status']==0">
							<el-button  type="info"  size="small"  disabled>未审核</el-button>
						</span>
						<span v-else-if="scope.row[item.keyword+'Status']==1"  @click="showStatus(scope.$index, scope.row,item.keyword,'通过','审核')" >
							<el-button  type="success" size="small" >通过</el-button>
						</span>
						<span v-else   @click="showStatus(scope.$index, scope.row,item.keyword,'无效','审核')" >
							<el-button  type="danger"  size="small">无效</el-button>
						</span>
					</span>
				</template>
			</el-table-column>
            <el-table-column   label="操作" min-width="100px" >
                <template slot-scope="scope">
					<el-button type="text" plain  icon="el-icon-edit" v-on:click="reviewData(scope.$index, scope.row)">审核数据</el-button>
					<el-button type="text" plain  icon="el-icon-view" v-on:click="queryReviewRecordDay(scope.$index, scope.row)">审核记录</el-button>
				</template>
            </el-table-column>
		</el-table>

		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[ 10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
			<el-button type="primary" @click.native="reviewDataOut"  :disabled="this.selsDay.length===0">数据审核</el-button>
		</el-col>

		<el-dialog :title="dayPreviewCon+'状态'" :visible.sync="statusVisible" 	width="20%"  :close-on-click-modal="false">
			<p>设备名称：{{statusRow.siteName}}</p>
			<p>{{dayPreviewCon}}时间：{{statusRow.statustime}}</p>
			<p>{{dayPreviewCon}}状态：{{statusRow.status}}</p>
			<p>{{dayPreviewCon}}人员：{{statusRow.userName}}</p>
			<p>标注信息：{{statusRow.remark}}</p>
		</el-dialog>

		<!-- 小时数据列表 -->
		<el-dialog title="审核数据" :visible.sync="reviewVisible"  :append-to-body="true"  width="80%"   top="5vh" :close-on-click-modal="false">
			<div  class="yenr_top">
				<div  class="juednm_1">
					<div  class="content">
						<div  class="ar">
							<div  class="bt"> 站点：  <span >{{dayRow.siteName}}-{{dayRow.functionalAreaName}} </span> </div>
							<div > 站点编号：{{dayRow.mn}} </div>
						</div>
						<div  class="hour">
							<div  class="bt">日期</div>
							<div >{{dayRow.time}} </div>
						</div>
						<div  class="hour">
							<div  class="bt">有效小时</div>
							<div > {{dayRow.total}} </div>
						</div>
					</div>
				</div>
				<div  class="uend_2">
					<div  class="neds_name">Ld(dB)</div>
					<div >{{dayRow.ld}}</div>
				</div>
				<div  class="uend_2">
					<div  class="neds_name">Ln(dB)</div>
					<div >{{dayRow.ln}}</div>
				</div>
				<div  class="uend_2">
					<div  class="neds_name">Ldn(dB)</div>
					<div >{{dayRow.ldn}}</div>
				</div>
			</div>
			<el-table :data="dataHourList" border highlight-current-row v-loading="listLoading" style="width: 100%;" :max-height="formHeight*0.8" 
			@selection-change="selsChangeHour"  size="mini" >
				<el-table-column type="selection"> </el-table-column>
				<el-table-column prop="hour" label="小时"  ></el-table-column>
				<el-table-column prop="isValid" label="审核状态"  >
					<template slot-scope="scope">
						<span v-if="scope.row.isValid==0" style="color: #3e6eff;"> 未审核</span>
						<span v-else-if="scope.row.isValid==1" style="color: green;">通过 </span>
						<span v-else style="color: red;">无效 </span>
					</template>
				</el-table-column>
				<el-table-column v-for="item in reviewWays" :prop="item.keyword" :label="item.name" :key="item.keyword" >
					<template slot-scope="scope">
						<span v-if="item.keyword=='preReview'">
							<span v-if="scope.row[item.keyword+'Status']==0"  style="color: #3e6eff;">未标记</span>
							<span v-else-if="scope.row[item.keyword+'Status']==1"  style="color: green;">通过</span>
							<span v-else  style="color: red;">异常</span>
						</span>
						<span v-else>
							<span v-if="scope.row[item.keyword+'Status']==0" style="color: #3e6eff;">未审核</span>
							<span v-else-if="scope.row[item.keyword+'Status']==1"   style="color: green;">通过</span>
							<span v-else    style="color: red;">无效</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="minuteCount" label="分钟数量"  >
					<template slot-scope="scope">
						<span v-if="scope.row.isMinuteValid=='valid'" style="color: green;">{{scope.row.minuteCount}} </span>
						<span v-else style="color: red;">{{scope.row.minuteCount}} </span>
					</template>
				</el-table-column>
				<el-table-column   label="操作" min-width="200" >
					<template slot-scope="scope">
						<el-button type="text" plain  icon="el-icon-edit" v-on:click="queryMinuteData(scope.$index, scope.row)">分钟数据</el-button>
						<el-button type="text" plain  icon="el-icon-view" v-on:click="queryReviewRecordHour(scope.$index, scope.row)">审核记录</el-button>
					</template>
				</el-table-column>
				<el-table-column
					v-for="item in facHourList" :prop="item.keyWord" :label="item.name" :key="item.keyWord" :min-width="item.name.length>7?'120p':''" >
					<template slot-scope="scope">
						<span v-if="scope.row[item.keyWord+'_color']!='-'" :style="'color:'+scope.row[item.keyWord+'_color']">{{scope.row[item.keyWord+"_data"]}}</span>
						<span v-else style="color:#000">{{scope.row[item.keyWord+"_data"]}}</span>
					</template> 
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click.native="deviceEvent">设备事件</el-button>
				<el-button type="primary" @click.native="getExamineHourList(dayRow)" >数据刷新</el-button>
				<el-button type="primary" @click.native="reviewDataChild('day')" >天数据审核</el-button>
				<el-button type="primary" @click.native="reviewDataChild('hour')"   :disabled="this.selsHour.length===0">小时数据审核</el-button>
				<el-button @click.native="cancleReview">取消</el-button>
			</div>
		</el-dialog>

		<!-- 天、小时数据审核记录 -->
		<el-dialog :title="recordTitle" :visible.sync="dialogRecordVisible"  :append-to-body="true"  width="80%" :close-on-click-modal="true">
			<el-table :data="dataRecordList" border highlight-current-row  size="mini">
				<el-table-column type="index" label="序号" key="index"></el-table-column >
				<el-table-column  prop="siteName" label="点位名称"  key="siteName"  v-if="recordType=='day'"></el-table-column>
				<el-table-column  prop="dataTime" label="数据时间"  key="dataTime"  ></el-table-column>
				<el-table-column  prop="status" label="审核状态"  key="status" >
					<template slot-scope="scope">
						<span v-if="scope.row.status==1||scope.row.status=='1'" style="color:green"> 通过 </span>
						<span v-else style="color:red">无效 </span>
					</template>
				</el-table-column>
				<el-table-column  prop="userName" label="审核人" key="userName"></el-table-column>
				<el-table-column  prop="time" label="审核时间"  key="time"></el-table-column>
				<el-table-column  prop="reasonStr" label="原因"   key="reasonStr" v-if="recordType=='hour'||recordType=='minute'"></el-table-column>
				<el-table-column  prop="remark" label="标注信息"  key="remark">
					<template slot-scope="scope">
						<span v-if="scope.row.remark==''" >  </span>
						<span v-else >
							<el-popover placement="bottom" 	title="标注信息" width="200" trigger="click"
								:content="scope.row.remark">
								<el-button slot="reference"  icon="el-icon-search" circle  size="small"></el-button>
							</el-popover>
						</span>
					</template>
				</el-table-column>
				<el-table-column  prop="imgUrl" label="佐证资料"  key="imgUrl"  v-if="recordType=='day'">
					<template slot-scope="scope">
						<span v-if="scope.row.imgUrl==''||scope.row.imgUrl==undefined" >  </span>
						<span v-else >
							<el-image   style="width: 30px; height: 16px;"  src="/static/query.png"   :preview-src-list="scope.row.srcList">  </el-image>
						</span>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>

		<!-- 分钟数据展示 -->
		<el-dialog title="分钟数据" :visible.sync="dialogMinuteVisible"  :append-to-body="true"  width="80%" top="5vh" :close-on-click-modal="false">
			<el-table :data="minuteDataList" border highlight-current-row v-loading="listLoading" style="width: 100%;" 
			@selection-change="selsChangeMinute"  :max-height="formHeight*0.8"  size="mini" >
				<el-table-column type="selection"> </el-table-column>
				<el-table-column  prop="time" label="数据时间"></el-table-column>
				<el-table-column prop="isValid" label="审核状态"  >
					<template slot-scope="scope">
						<span v-if="scope.row.isValid==0" style="color: #3e6eff;"> 未审核</span>
						<span v-else-if="scope.row.isValid==1" style="color: green;">通过 </span>
						<span v-else style="color: red;">无效 </span>
					</template>
				</el-table-column>
				<el-table-column v-for="item in reviewWays" :prop="item.keyword" :label="item.name" :key="item.keyword" >
					<template slot-scope="scope">
						<span v-if="item.keyword=='preReview'">
							<span v-if="scope.row[item.keyword+'Status']==0"  style="color: #3e6eff;">未标记</span>
							<span v-else-if="scope.row[item.keyword+'Status']==1"  style="color: green;">通过</span>
							<span v-else  style="color: red;">异常</span>
						</span>
						<span v-else>
							<span v-if="scope.row[item.keyword+'Status']==0" style="color: #3e6eff;">未审核</span>
							<span v-else-if="scope.row[item.keyword+'Status']==1"   style="color: green;">通过</span>
							<span v-else    style="color: red;">无效</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="time" label="是否校准">
					<template slot-scope="scope">
						<span v-if="scope.row.cal=='1'"  style="color:red;cursor: pointer;" >是</span>
						<span v-else >否</span>
					</template>
				</el-table-column>
				<el-table-column   label="操作" min-width="280" >
					<template slot-scope="scope">
						<el-button type="text" plain  icon="el-icon-edit" v-on:click="showReviewMinute(scope.$index, scope.row)">数据审核</el-button>
						<el-button type="text" plain  icon="el-icon-view" v-on:click="queryReviewRecordMinute(scope.$index, scope.row)">审核记录</el-button>
						<el-button type="text" plain  icon="el-icon-view" v-if="scope.row.recordings!='-'" 
						 v-on:click="queryRecord(scope.$index, scope.row)">查看录音</el-button>
					</template>
				</el-table-column>
				<el-table-column
					v-for="item in facHourList" :prop="item.keyWord" :label="item.name" :key="item.keyWord"  :min-width="item.name.length>7?'120p':''" >
					<template slot-scope="scope">
						<span v-if="scope.row[item.keyWord+'_color']!='-'" :style="'color:'+scope.row[item.keyWord+'_color']">{{scope.row[item.keyWord+"_data"]}}</span>
						<span v-else style="color:#000">{{scope.row[item.keyWord+"_data"]}}</span>
					</template> 
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click.native="showReviewMinute"  :disabled="this.selsMinute.length===0">数据审核</el-button>
				<el-button @click.native="cancleMinuteReview">取消</el-button>
			</div>
		</el-dialog>

		<!-- 审核界面，小时、天、分钟 -->
		<el-dialog :title="SetRecordTitle" :visible.sync="dialogSetRecordVisible"  :append-to-body="true"  width="60%" :close-on-click-modal="false">
			<el-form :model="formSetRecord" label-width="80px" :rules="recordType=='day'?validDayRules:validHourRules"  ref="formSetRecord" v-loading="reviewlistLoading">
				<el-form-item label="审核状态"  prop="status">	
					<el-select v-model="formSetRecord.status" placeholder="请选择状态">
						<el-option label="通过" value="1" ></el-option>
						<el-option label="无效" value="2" ></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择原因"   prop="reasonId"  v-if="recordType=='hour'||recordType=='minute'">
					<el-select v-model="formSetRecord.reasonId" placeholder="请选择原因" filterable>
						<el-option v-for="item in reasonList" :label="item.name" :value="item.id" :key="item.id"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="标注信息"   prop="remark" >
					<el-input v-model="formSetRecord.remark" ></el-input>
				</el-form-item>
				<el-form-item label="佐证材料"  v-if="recordType=='day'"   prop="img">
					<el-upload class="upload-demo" action="#" :http-request="httpRequest" ref="upload" name="file" :on-change="change"  accept="image/*" 
						:file-list="fileListShow"  :on-remove="remove" list-type="picture" multiple :auto-upload="false">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传图片文件，且最好不超过500kb</div>
					</el-upload>
			</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSetRecordSubmit">取消</el-button>
				<el-button type="primary" @click.native="reviewDataChildSubmit">提交</el-button>
			</div>
		</el-dialog>

		<el-dialog title="设备事件详情" :visible.sync="dialogEventVisible"  :append-to-body="true"  width="60%" :close-on-click-modal="true">
			<el-table :data="eventList" border highlight-current-row v-loading="listLoading" style="width: 100%;" :max-height="formHeight*0.8"   size="small" >
				<el-table-column type="index" label="序号" ></el-table-column>
				<el-table-column prop="time" label="时间"    ></el-table-column>
				<el-table-column prop="type" label="类型"    ></el-table-column>
				<el-table-column prop="remark" label="偏差/事件"   ></el-table-column>
			</el-table>
		</el-dialog>

		<el-dialog  title="详情" :visible.sync="noiseRecordVisible" :close-on-click-modal="true">
            <el-table :data="noiseRecordList" border  highlight-current-row v-loading="listLoading"  style="width: 100%;" :max-height="formHeight"   size="small" >
                <el-table-column type="index" label="序号"  ></el-table-column>
                <el-table-column prop="time" label="时间"   sortable  ></el-table-column>
				<el-table-column prop="noisesource" label="声源识别">
				<template slot-scope="scope">
					<span v-if="scope.row.noisesource==null||scope.row.noisesource==''">待识别</span>
					<span v-else >{{scope.row.noisesource}}</span>
				</template>
			</el-table-column>
            </el-table>
        </el-dialog>

	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,getEventList,getReviewWay,getExamineHourList,
		getReasonList,reviewHourData,reviewDayData,reviewMinuteData,getExamineDayList,getExamineMinuteList} from '../../api/api';
	import {setDeviceEvent,in_array,pad2,factorExcept,minFactorExcept,hourFactorExcept,formatDate} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'

	export default {
	components: { myButton },
		data() {
			return {
				filters: {
					projectId:"",
					mn:"",
					time:""
				},
				listLoading: false,
				recorddataDayList:[],
				activeNum:0,
				firstFlag:true,
				devices:[],
				facHourList:[],
				facMinList:[],
				projects:[],
				formHeight:0,

				type:sessionStorage.getItem("type"),

				reviewVisible:false,
				dataDayList:[],
				dataDayMap:new Map(),
				dataHourList:[],
				dataHourMap:new Map(),

				dataMap:new Map(),
				reasonMap:new Map(),
				minid:0,
				wayid:0,
				mn:'',
				validHourRules:{
					status: [
						{ required: true, message: '必选', trigger: 'change'  }
					]
				},
				validDayRules:{
					status: [
						{ required: true, message: '必选', trigger: 'change'   }
					]
				},

				dialogRecordVisible:false,
				dataRecordList:[],

				total: 0,
				page:1,
				pageSize:10,
				userId:sessionStorage.getItem('userId'),
				reviewWays:[],
				statusVisible:false,
				statusRow:{},
				dayRow:{},
				minuteRow:{},

				dialogMinuteVisible:false,
				minuteDataList:[],
				recordTitle:'天数据审核记录',
				recordType:"day",
				recordDayMulti:true,
				recordChild:false,

				dialogSetRecordVisible:false,
				SetRecordTitle:'审核天数据',
				reasonList:[],
				formSetRecord:{
					status:'',
					reasonId:'',
					remark:''
				},
				fileList:[],
				fileListShow:[],
				length:0,

				dialogEventVisible:false,
				eventList:[],
				dayPreviewCon:'审核',
				minuteDataIds:'',
				hourDataIds:'',
				dayDataIds:'',
				selsMinute:[],
				selsHour:[],
				selsDay:[],
				reviewlistLoading:false,
				noiseRecordList:[],
				noiseRecordVisible:false
			}			
		},
		methods: {
			queryRecord(i,row){
            	this.noiseRecordList=row.recordings;
				this.noiseRecordVisible=true;
			},
			selsChangeMinute: function (sels) {
                this.selsMinute = sels;
			},
			selsChangeDay: function (sels) {
                this.selsDay = sels;
			},
			selsChangeHour: function (sels) {
                this.selsHour = sels;
			},
			cancleMinuteReview(){
				this.dialogMinuteVisible=false;
			},
			clickBtn(type){
				if(type=="query"){
					this.getReviewRecordDay();
				}else if(type=="reset"){
					this.reset();
				}
			},
			queryMinuteData(i,row){
				if(row==undefined){
					row=this.minuteRow;
				}else{
					this.minuteRow=row;
				}
				this.dialogMinuteVisible=true;
				//小时取分钟
				var time1=new Date(row.time);
				var endDate=formatDate(time1);

				time1.setHours(time1.getHours()-1);
				var startDate=formatDate(time1);

				let para = {
                    mn: this.dayRow.mn,
					startDate: startDate,
                    endDate: endDate
				};
				
				this.listLoading = true;
				getExamineMinuteList(para).then((res) => {
					this.listLoading = false;
					if(res.data.result=="true"){
						this.minuteDataList = res.data.data;
                    }
				});
			},
			deviceEvent(){
				this.dialogEventVisible=true;
				//获取事件信息
				this.eventList=[];
				this.getEventList(0);
				this.getEventList(1);
			},
			//获取历史数据信息
			getEventList(eventType){
				let para = {
					eventType:eventType,
					page: 1,
					pageSize:100,
                    mn: this.dayRow.mn,
					startDate: this.dayRow.time+" 00:00:00",
                    endDate: this.dayRow.time+" 23:59:59"
				};
				getEventList(para).then((res) => {
					var dataList = res.data.data;
					if(eventType==0){
						this.checkInfo={};
						if(dataList.length>0){
							for (let index = 0; index < dataList.length; index++) {
								const element = dataList[index];
								element.type='自检';
								element.remark=element.diff;
								element.index=this.eventList.length;
								this.eventList.push(element);
							}
						}
					}else if(eventType==1){
						this.stateInfo={};
						if(dataList.length>0){
							for (let index = 0; index < dataList.length; index++) {
								const data = dataList[index];
								data.remark=setDeviceEvent(data);
								element.type='报警';
								element.index=this.eventList.length;
								this.eventList.push(element);
							}

						}
					}
				
				});
			},
			showStatus(i,row,way,status,dayPreviewCon){
				this.dayPreviewCon=dayPreviewCon;
				this.statusVisible=true;
				this.statusRow=row;
				this.statusRow.statustime=row[way].time;
				this.statusRow.status=status;
				this.statusRow.remark=row[way].remark;
				this.statusRow.userName=row[way].userName;
			},
			queryReviewRecordHour(j,row){
				this.recordTitle="小时数据审核记录";
				this.dataRecordList=[];
				this.recordChild=true;
				this.recordType="hour";

				this.dialogRecordVisible=true;
				for(var i=0;i<this.reviewWays.length;i++){
					var obj=row[this.reviewWays[i]['keyword']];
					if(obj!="null"&&obj!=null&&this.reviewWays[i]['keyword']!="preReview"){
						obj.siteName=row.siteName;
						obj.dataTime=row.time;
						obj.reviewType=this.reviewWays[i]['name'];
						obj.reasonStr=this.reasonMap.get(obj.reasonId);
						this.dataRecordList.push(obj);
					}
				}
			},
			queryReviewRecordMinute(j,row){
				this.recordTitle="分钟数据审核记录";
				this.dataRecordList=[];
				this.recordChild=false;
				this.recordType="minute";

				this.dialogRecordVisible=true;
				for(var i=0;i<this.reviewWays.length;i++){
					var obj=row[this.reviewWays[i]['keyword']];
					if(obj!="null"&&obj!=null&&this.reviewWays[i]['keyword']!="preReview"){
						obj.siteName=row.siteName;
						obj.dataTime=row.time;
						obj.reviewType=this.reviewWays[i]['name'];
						obj.reasonStr=this.reasonMap.get(obj.reasonId);
						this.dataRecordList.push(obj);
					}
				}
			},
			queryReviewRecordDay(j,row){
				this.recordTitle="天数据审核记录";
				this.dataRecordList=[];
				this.recordChild=false;
				this.recordType="day";
				this.dialogRecordVisible=true;
				for(var i=0;i<this.reviewWays.length;i++){
					var obj=row[this.reviewWays[i]['keyword']];
					if(obj!="null"&&obj!=null&&this.reviewWays[i]['keyword']!="preReview"){
						obj.siteName=row.siteName;
						obj.dataTime=row.time;
						this.dataRecordList.push(obj);
					}
				}
			},
			cancleReviewChild(){
				this.dialogRecordVisible=false;
			},
			reviewDataChild(recordType){
				this.recordType=recordType;
				this.dialogSetRecordVisible=true;
				if(this.recordType=="hour"){
					this.SetRecordTitle="审核小时数据";
					this.getReasonList();
					var status1=0;
					var status2=0;
					for (let index = 0; index < this.selsHour.length; index++) {
						const element = this.selsHour[index];
						if(element.preReviewStatus==1){
							status1++;
						}else if(element.preReviewStatus==2){
							status2++;
						}
					}
					if(status1<status2){
						this.formSetRecord.status='2';
					}else{
						this.formSetRecord.status='1';
					}
				}else{//单条天数据审核
					this.SetRecordTitle="审核天数据";
					this.recordDayMulti=false;
					if(this.dayRow.preReviewStatus==2){
						this.formSetRecord.status='2';
					}else{
						this.formSetRecord.status='1';
					}
				}
			},
			showReviewMinute(i,row){
				this.dialogSetRecordVisible=true;
				this.SetRecordTitle="审核分钟数据";
				this.recordType="minute";
				this.getReasonList();
				if(row!=undefined){
					this.minuteDataIds=row.id;
					if(row.preReviewStatus==2){
						this.formSetRecord.status='2';
					}else{
						this.formSetRecord.status='1';
					}
				}else{
					this.minuteDataIds = this.selsMinute.map(item => item.id).toString();
					var status1=0;
					var status2=0;
					for (let index = 0; index < this.selsMinute.length; index++) {
						const element = this.selsMinute[index];
						if(element.preReviewStatus==1){
							status1++;
						}else if(element.preReviewStatus==2){
							status2++;
						}
					}
					if(status1<status2){
						this.formSetRecord.status='2';
					}else{
						this.formSetRecord.status='1';
					}
				}
			},
			remove:function(file, fileList){
				if(file.name==undefined){
					var i=0;
					this.fileList.forEach(element => {
						if(element.uid==file.uid){
							this.fileList.splice(i, 1);
							return;
						}
						i++;
					});
				}
			},
			change:function(file, fileList){
				//判断上传文件数量
				this.length=document.querySelector("input[type=file]").files.length;
				if(this.length>0){
					Array.from(document.querySelector("input[type=file]").files).forEach(file=>{
						if(this.fileList.indexOf(file) == -1){
							this.fileList.push(file);
						}
					})
				}
				return false;
			},
			httpRequest(){}, 
			reviewDataChildSubmit(){
				this.$refs.formSetRecord.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							let formData = new FormData();
							if(this.userId==""||this.userId==undefined){
								this.$message({
									message: "用户已离线，请重新登录",
									type: 'warn'
								})
								this.$router.push({ path: '/login' });
								return;
							}
							formData.append("status",this.formSetRecord.status);

							if(this.formSetRecord.remark!=undefined){
								formData.append("remark",this.formSetRecord.remark);
							}
							formData.append("userid",this.userId);

							this.reviewlistLoading=true;

							if(this.recordType=="hour"){
								formData.append("mn",this.dayRow.mn);
								formData.append("ids", this.selsHour.map(item => item.id).toString());
								if(this.formSetRecord.reasonId!=''&&this.formSetRecord.reasonId!=undefined){
									formData.append("reasonId",this.formSetRecord.reasonId);
								}
								reviewHourData(formData).then((res) => {
									this.reviewlistLoading=false;
									if(res.data.result==true||res.data.result=="true"){
										this.$message({
											message: "提交成功",
											type: 'success'
										})
										this.dialogSetRecordVisible=false;
										this.dialogRecordVisible=false;
										this.$refs.formSetRecord.resetFields();
										this.getExamineHourList(this.dayRow);
										//重新展示天数据
										try{
											var dayData=res.data.dayData;
											var dayIndex=this.dataDayMap.get(dayData.id);
											this.dayRow.ld=dayData.n00004;
											this.dayRow.ln=dayData.n00005;
											this.dayRow.ldn=dayData.n00007;
											this.dataDayList[dayIndex].ld=dayData.n00004;
											this.dataDayList[dayIndex].ln=dayData.n00005;
											this.dataDayList[dayIndex].ldn=dayData.n00007;
										}catch(err){

										}
									}else{
										this.$message({
											message: res.data.msg,
											type: 'error'
										})
									}
								}).catch(err => {
									this.reviewlistLoading=false;
									this.$message({
										message: "提交出错，请重试",
										type: 'error'
									})
								});
							}else if(this.recordType=="day"){
								var i=0;
								this.fileList.forEach(file=> {
									formData.append("files"+i, file);
									i++;
								});
								if(this.recordDayMulti){
									formData.append("ids", this.selsDay.map(item => item.id).toString());
									formData.append("mns", this.selsDay.map(item => item.mn).toString());
								}else{
									formData.append("ids",this.dayRow.id);
									formData.append("mns",this.dayRow.mn);
								}

								//	走接口
								reviewDayData(formData).then(res => {
									this.fileList=[];
									this.fileListShow=[];
									this.reviewlistLoading=false;
									//此处重置文件中间存储变量是为了相同文件能够重复传递
									if (res.data.result==true||res.data.result=="true") {
											this.$message({
												message: '提交成功',
												type: 'success'
											});
											this.dialogSetRecordVisible=false;
											this.dialogRecordVisible=false;
											this.reviewVisible=false;
											this.$refs.formSetRecord.resetFields();
											this.getReviewRecordDay();
											this.recordDayMulti=true;
										}else{
											this.$message({
												message: res.data.msg,
												type: 'error'
											})
										}
									})
								.catch(err => {
									this.reviewlistLoading=false;
									this.$message({
										message: "提交出错，请重试",
										type: 'error'
									})
								});	
							}else{
								if(this.formSetRecord.reasonId!=''&&this.formSetRecord.reasonId!=undefined){
									formData.append("reasonId",this.formSetRecord.reasonId);
								}
								formData.append("ids",this.minuteDataIds);
								formData.append("mn",this.dayRow.mn);

								//	走接口
								reviewMinuteData(formData).then(res => {
									this.reviewlistLoading=false;
									//此处重置文件中间存储变量是为了相同文件能够重复传递
									if (res.data.result==true||res.data.result=="true") {
											this.$message({
												message: '提交成功',
												type: 'success'
											});
											this.dialogSetRecordVisible=false;
											this.dialogRecordVisible=false;
											this.$refs.formSetRecord.resetFields();
											this.queryMinuteData();

											//重新展示小时和天数据
											try{
												var dayData=res.data.dayData;
												var dayIndex=this.dataDayMap.get(dayData.id);
												this.dayRow.ld=dayData.n00004;
												this.dayRow.ln=dayData.n00005;
												this.dayRow.ldn=dayData.n00007;
												this.dataDayList[dayIndex].ld=dayData.n00004;
												this.dataDayList[dayIndex].ln=dayData.n00005;
												this.dataDayList[dayIndex].ldn=dayData.n00007;
											}catch(err){

											}
											

											try{
												var hourData=res.data.hourData;
												var hourIndex=this.dataHourMap.get(hourData.id);
												var keys=Object.keys(hourData);
												for (let index = 0; index < keys.length; index++) {
													const element = keys[index];
													if(element=="id"||element=="time"){
														continue;
													}
													if(hourData[element]!=null){
														this.dataHourList[hourIndex][element+"_data"]=hourData[element];
													}
												}
											}catch(err){

											}


										}else{
											this.$message({
												message: res.data.msg,
												type: 'error'
											})
										}
									})
								.catch(err => {
									this.reviewlistLoading=false;
									this.$message({
										message: "提交出错，请重试",
										type: 'error'
									})
								});	
							}
						});
					}
				});
			},
			reviewData(j,row){
				this.reviewVisible=true;
				this.dayRow=row;
				this.getExamineHourList(row);
			},
			reviewDataOut(){
				this.SetRecordTitle="审核天数据";
				this.recordType="day";
				this.recordDayMulti=true;//天数据审核 多选
				this.dialogSetRecordVisible=true;
				var status1=0;
				var status2=0;
				for (let index = 0; index < this.selsDay.length; index++) {
					const element = this.selsDay[index];
					if(element.preReviewStatus==1){
						status1++;
					}else if(element.preReviewStatus==2){
						status2++;
					}
				}
				if(status1<status2){
					this.formSetRecord.status='2';
				}else{
					this.formSetRecord.status='1';
				}
			},
			cancleSetRecordSubmit(){
				this.dialogSetRecordVisible=false;
				this.$refs.formSetRecord.resetFields();
			},
			cancleReview(){
				this.reviewVisible=false;
			},
			reset(){
				this.filters.projectId="";
				this.filters.mn="";
				this.getReviewRecordDay();
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getReviewRecordDay();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getReviewRecordDay();
			},
			//获取因子列表
			getReviewWay() {
				this.listLoading = true;
				getReviewWay({}).then((res) => {
					this.listLoading = false;
					this.reviewWays = res.data.data;
				});
			},
			getExamineHourList(row){
				let para = {
                    mn: row.mn,
					time: row.time
				};
				this.listLoading = true;
				getExamineHourList(para).then((res) => { 
				this.listLoading = false;
					
					this.dayRow.total=res.data.total;
					this.dayRow.functionalAreaName = res.data.functionalAreaName; 
					var fac=res.data.facList;
					this.facHourList=[];
					this.facMinList=[];
					var arr=factorExcept();
					var arrmin=minFactorExcept();
					var arrhour=hourFactorExcept();
					for (var i=0;i<fac.length;i++) {
						var element=fac[i];
						if(in_array(element,arr)){
							continue
						}
						var obj=JSON.parse(sessionStorage.getItem(element));
						if(obj.unit.trim()!=""){
							obj.name=obj.name+'('+obj.unit+')';
						}else{
							obj.name=obj.name;
						}
						if(!in_array(element,arrmin)){
							this.facMinList.push(obj);
						}
						if(!in_array(element,arrhour)){
							this.facHourList.push(obj);
						}
					}
					this.dataHourList=res.data.data;
					this.dataHourMap=new Map();
					for (let index = 0; index < this.dataHourList.length; index++) {
						const element = this.dataHourList[index];
						this.dataHourMap.set(element.id,index);
					}
				});
			},
			getReviewRecordDay(){
				let para = {
					page: this.page,
					pageSize:this.pageSize,
                    userId:this.userId,
					time: this.filters.time
				};
				if(this.filters.projectId!=""){
					para.projectId=this.filters.projectId;
				}
				if(this.filters.mn!=""){
					para.mn=this.filters.mn.toString();
				}
				if(para.userId==""||para.userId==undefined){
                    this.$message({
                        message: "用户已离线，请重新登录",
                        type: 'warn'
                    })
                    this.$router.push({ path: '/login' });
                    return;
                }
				this.listLoading = true;
				getExamineDayList(para).then((res) => { 
					
					this.listLoading = false;
					this.total=res.data.total;
					this.dataDayList = res.data.data; 
					this.dataDayMap=new Map();
					var j=0;
					this.dataDayList.forEach(element => {
						for(var i=0;i<this.reviewWays.length;i++){
							var obj=element[this.reviewWays[i]['keyword']];
							if(obj==null){
								break;
							}
							if(obj.imgUrl!=''&&obj.imgUrl!=undefined){
								var arr=[];
								var imgarr=obj.imgUrl.split(';');
								for(var j=0;j<imgarr.length;j++){
									if(imgarr[j]==""){
										continue;
									}
									var url=getResourceUrl()+"photo/"+imgarr[j];
									arr.push(url);
								}
								// arr=["https://pics4.baidu.com/feed/1e30e924b899a9012d24a666516fa2710308f556.jpeg?token=e8489a00d5c0d522b9cbf308797f3f38",
								// "https://pics0.baidu.com/feed/94cad1c8a786c917e630400c9ac7d8c53ac757dc.jpeg?token=32169530730c9857e279213cc93f4104"]
								obj.srcList=arr;
							}
						}
						this.dataDayMap.set(element.id,j);
						j++;
					});
				});
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						if(this.$route.query.projectId==undefined){
							this.filters.projectId=this.projects[0].projectId;
						}else{
							this.filters.projectId=this.$route.query.projectId;
						}
						this.getDevices();
					}
				});
			},
			getReasonList() {
				if(this.reasonList.length>0){
					return;
				}
				this.listLoading = true;
				getReasonList().then((res) => {
					this.listLoading = false;
					if(res.data.result=="false"){
                        this.$message({
                            message: "查询出错，请重试",
                            type: 'error'
                        })
						return;
                    }
					this.reasonList = res.data.data;
					for (let index = 0; index < this.reasonList.length; index++) {
						const element = this.reasonList[index];
						this.reasonMap.set(element.id,element.name);
						
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					this.filters.mn=[];
					
					if(this.firstFlag){
						this.firstFlag=false;
						if(this.$route.query.mn!=undefined){
							this.filters.mn.push( this.$route.query.mn);
						}
						this.getReviewRecordDay();
					}
				});
            },
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				if(this.$route.query.time!=undefined){
					this.filters.time=this.$route.query.time;
				}else{
					var start = new Date();
					//设置不同的时间区间
					start.setTime(start.setDate(start.getDate()-1));
					this.filters.time=start.getFullYear()+"-"+pad2((start.getMonth()+1))+"-"+pad2((start.getDate()));
				}
				this.getProjects();
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)

			this.setTime();
			this.getReviewWay();
			this.getReasonList();
		}, 
		// 监听,当路由发生变化的时候执行
		watch: {
			$route: {
				handler: function(val, oldVal){
					if(val.path!="/reviewDataMa"){
						return;//其他路径不处理
					}
					if(this.firstFlag){
						//第一次加载不处理
					}else{
						if(val.fullPath.indexOf('/reviewDataMa?mn=')!=-1){
							this.filters.time=this.$route.query.time;
							this.firstFlag=true;
							this.getProjects();
						}
					}
				},
				// 深度观察监听
				deep: true
			}
		},
	}

</script>

<style scoped lang="scss">
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
	.vxe-modal--wrapper{
		z-index: 3000!important;
	}
	.type--datetime{
		z-index: 3000!important;
	}

	.yenr_top {
		margin-bottom: 22px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		.juednm_1 {
			width: 33%;
			height: 100px;
			border-radius: 10px;
			background-color: #578cfa;
			color: #fff;
			margin-right: 10px; 
		}
		.juednm_1 .content {
			display: -webkit-box;
			display: -ms-flexbox;
			display: flex;
			font-size: 14px;
			margin-top: 20px;
		}
		.juednm_1 .content .ar {
			-webkit-box-flex: 3;
			-ms-flex: 3;
			flex: 3;
			text-align: center;
		}.juednm_1 .content .bt {
			margin-bottom: 10px;
		}
		.juednm_1 .content .hour {
			-webkit-box-flex: 1;
			-ms-flex: 1;
			flex: 1;
			text-align: center;
		}
		.uend_2 {
			width: 22%;
			height: 100px;
			border-radius: 10px;
			background-color: #54c0f9;
			color: #fff;
			text-align: center;
			margin-right: 10px;
		}
		.uend_2 div:first-child {
			padding: 20px 0;
		}
		.uend_2 div:nth-child(2) {
			font-weight: 700;
		}
		.neds_name {
			font-size: 18px;
		}
	}

</style>


// WEBPACK FOOTER //
// ReviewData.vue?0d4ca9b0